export default {
  EDIT_IMPACT_ASSESSMENT: 'EDIT_IMPACT_ASSESSMENT',
};
